/**
 * @generated SignedSource<<c549c53148c54f059ad56ede33a36184>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductApplicationStatus = "acceptance_failed" | "accepted" | "pending" | "rejected" | "%future added value";
export type SubmitCheckoutApplicationInput = {
  checkoutId: string;
};
export type ProductRegistrationApplyStep_SubmitApplicationMutation$variables = {
  input: SubmitCheckoutApplicationInput;
};
export type ProductRegistrationApplyStep_SubmitApplicationMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly status: ProductApplicationStatus;
    } | null;
  };
};
export type ProductRegistrationApplyStep_SubmitApplicationMutation = {
  response: ProductRegistrationApplyStep_SubmitApplicationMutation$data;
  variables: ProductRegistrationApplyStep_SubmitApplicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitCheckoutApplicationResponse",
    "kind": "LinkedField",
    "name": "submitCheckoutApplication",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductApplication",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductRegistrationApplyStep_SubmitApplicationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductRegistrationApplyStep_SubmitApplicationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b9ea62eaebbceeaebf2433ad925ea6ab",
    "id": null,
    "metadata": {},
    "name": "ProductRegistrationApplyStep_SubmitApplicationMutation",
    "operationKind": "mutation",
    "text": "mutation ProductRegistrationApplyStep_SubmitApplicationMutation(\n  $input: SubmitCheckoutApplicationInput!\n) {\n  response: submitCheckoutApplication(input: $input) {\n    node {\n      id\n      status\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6be466eb55b53bf8da5abd3c70bdbcdf";

export default node;
